import { render, staticRenderFns } from "./OrganizationManagerPositionInput.vue?vue&type=template&id=0a10dae0&"
import script from "./OrganizationManagerPositionInput.vue?vue&type=script&lang=js&"
export * from "./OrganizationManagerPositionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports